import moment from "moment";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { juneTrack } from "../../utils/june/analytics";

import { taskPopupState } from "../../recoil/taskDetail/taskPopupState";

import { taskDetailHeightState } from "../../recoil/taskDetail/taskDetailHeightState";

import TaskDetailTitle from "./Title/TaskDetailTitle";
import DateModal from "./DateTime/DateModal";
import GuestModal from "./Guest/GuestModal";
import SpaceModal from "../../compoenets/organism/TaskDetail/Space/SpaceModal";
import LinkModal from "./Link/LinkModal";
import TaskNote from "./Note/TaskNote";
import VideoModal from "./Video/VideoModal";
import NotePreview from "./Note/NotePreview";

import clsx from "clsx";

import "react-datepicker/dist/react-datepicker.css";
import "./DateTime/CustomDatePicker.css";

import styles from "./TaskSetting.module.css";
import { inProgressAndCompletedSpaceListState } from "../../recoil/spaces/inProgressSpaceListState";
import { getSpaceColor } from "../../services/space/space.service";
import { getBlockTypeFlags } from "../../utils/common/block/getBlockTypeFlags";
import { ItemStatus, RecurringOption } from "../../types/block/enum";
import { LINK_FIELD_NAME } from "../../constants/block/LinkData";
import { useUpdateCalendarCheckboxMutation } from "../../react-query/calendar/useUpdateCalendarCheckboxMutation";
import { logger } from "../../utils/logger";
import { JUNE_EVENT } from "../../hooks/june/juneEvent";
import { usePreference } from "../../hooks/preference/usePreference";

function isValidationBuffMode(data) {
  if (data === null) {
    logger.info("Data is null while validating buff mode");
    return false;
  }

  const isValidLink =
    data.hangoutLink && typeof data.hangoutLink === "string" && data.hangoutLink.trim() !== "";
  const hasAttendees = Array.isArray(data.attendees) && data.attendees.length > 0;

  return isValidLink || hasAttendees;
}

export default function TaskSetting({
  initialData,
  titleRef,
  expand,
  onSave,
  onClose,

  setVisibilityType,
  isChangeNote,
  isDisabled,
  // NOTE: 지울 때 이 component를 사용하는 JS 파일에서도 꼭 확인해서 같이 지우세요
  // WARN: not being used
  onChangeLocation,
  // WARN: not being used
  currentLocation,
  linkMoreModalRef,
  videoCreateModalRef,
  repeatModalRef,
  projectDropdownRef,

  guestDropdownRef,
  // WARN: not being used
  locationDropdownRef,
  repeatAddModalRef,
  mutateMeetingCode,
  isPendingMeetingCode,
  meetingCode,
  setIsModalNoteClicked,
  isModalNoteClicked,
  localTitle,
  handleChangeLocalTitle,
  isInputQuickSpaceShortcut,
  setIsInputQuickSpaceShortcut,
}) {
  const [taskDetail, setTaskDetail] = useRecoilState(taskPopupState);
  const [isDone, setIsDone] = useState(taskDetail.data?.itemStatus === ItemStatus.COMPLETED);
  const nowDate = new Date();
  const minutes = nowDate.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  nowDate.setMinutes(roundedMinutes);

  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);

  // TODO : replace this locationLocation with real data
  const [isAllDay, setIsAllDay] = useState(null);
  const [isBuffMode, setIsBuffMode] = useState(null);

  // DateTime Picker 상태들
  const [isTimeStartOpen, setIsTimeStartOpen] = useState(false);
  const [isTimeEndOpen, setIsTimeEndOpen] = useState(false);
  const [isDateStartOpen, setIsDateStartOpen] = useState(false);
  const [isDateEndOpen, setIsDateEndOpen] = useState(false);

  const taskDetailHeight = useRecoilValue(taskDetailHeightState);

  const [inProgressAndCompletedSpaceList, setInProgressAndCompletedSpaceList] = useRecoilState(
    inProgressAndCompletedSpaceListState
  );

  const [noteModalHeight, setNoteModalHeight] = useState(taskDetailHeight);
  const [hover, setHover] = useState(false);

  // TODO 여기 클라이언트 상태 업데이트 필요
  const { mutate: updateBlockItemStatus } = useUpdateCalendarCheckboxMutation();
  const { preference: userPreference } = usePreference();
  const timeFormat = userPreference?.timeFormat;
  const defaultVisibility = userPreference?.defaultVisibility;

  const { spaceId } = taskDetail.data;
  const { isTask, isEvent } = getBlockTypeFlags(taskDetail.data?.blockType);

  useEffect(() => {
    const noteModalHeaderHeight = 42;
    const noteModalFooterHeight = 50;
    const taskDetailBorderHeight = 2;

    const taskDetailModalHeight = taskDetailHeight > 600 ? 600 : taskDetailHeight;
    setNoteModalHeight(
      taskDetailModalHeight - noteModalHeaderHeight - noteModalFooterHeight - taskDetailBorderHeight
    );
  }, [isModalNoteClicked]);

  useEffect(() => {
    if (taskDetail.isNewBlock) {
      titleRef?.current?.focus();
    }

    setIsAllDay(taskDetail.data?.allDay);
    setIsBuffMode(!isValidationBuffMode(taskDetail.data));

    const start = taskDetail.data?.start ? new Date(taskDetail.data?.start) : null;
    let end = taskDetail.data?.end ? new Date(taskDetail.data?.end) : null;

    if (taskDetail.data?.allDay && end) {
      end = moment(end).subtract(1, "days").toDate();
    }

    setStartDateTime(start);
    setEndDateTime(end);
  }, []);

  useEffect(() => {
    handleResizeHeight();
  }, []);

  const handleCheckbox = () => {
    logger.info(`handleCheckbox called in TaskSetting.`);
    if (isDisabled) {
      return;
    }
    // 닫히면서 checked/unchecked 상태 잠깐 보여주기 위한 것으로 이해
    setIsDone((prev) => !prev);

    if (!initialData?.id) {
      logger.info(`Updating block with id: ${initialData?.id} in TaskSetting.`);
    }

    const hasRecurrenceRules = initialData?.recurrence?.length > 0;
    const isRecurringInstance = Boolean(initialData.originalId);
    const isRecurringBlock = hasRecurrenceRules || isRecurringInstance;

    // 반복이면 id, payload가 다름
    // this로 반복이벤트 수정시에는 꼭 originalStart를 넣어줘야함
    const payload = { itemStatus: isDone ? ItemStatus.IN_PROGRESS : ItemStatus.COMPLETED };
    const updatePayload = isRecurringBlock
      ? {
          ...payload,
          type: RecurringOption.THIS,
          originalStart: initialData.originalStart ?? initialData?.start,
        }
      : payload;

    juneTrack(
      updatePayload.itemStatus === ItemStatus.IN_PROGRESS
        ? JUNE_EVENT.UNDONE_TASK
        : JUNE_EVENT.DONE_TASK,
      {
        location: "block_detail",
      }
    );

    updateBlockItemStatus({
      id: initialData?.id,
      payload: updatePayload,
      prevData: initialData,
    });

    onClose();
  };

  const handlePropertyBtn = (e = null, name) => {
    if (name !== "project") {
      if (e && e.target !== e.currentTarget) return;
    }
  };

  // TODO: linkData 같은 경우에만 배열로 처리
  const updateTaskConfig = (key, value) => {
    // if (isEnter) return;
    if (key === LINK_FIELD_NAME) {
      setTaskDetail((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [key]: [...(prevState.data?.[key] ?? []), value],
        },
      }));
    } else {
      setTaskDetail((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [key]: value,
        },
      }));
    }
  };

  const handleResizeHeight = () => {
    if (titleRef.current) {
      titleRef.current.style.height = "auto"; //height 초기화

      if (titleRef.current.scrollHeight < 98) {
        titleRef.current.style.height = titleRef.current.scrollHeight + "px";
      } else {
        titleRef.current.style.height = "98px";
      }
    }
  };

  const handleTimeStartChange = (newTime) => {
    if (!startDateTime || !endDateTime) return;
    const previousDiff = endDateTime.getTime() - startDateTime.getTime();
    const updatedStart = new Date(startDateTime);
    updatedStart.setHours(newTime.getHours(), newTime.getMinutes(), 0, 0);
    const updatedEnd = new Date(updatedStart.getTime() + previousDiff);

    setStartDateTime(updatedStart);
    setEndDateTime(updatedEnd);

    setIsTimeStartOpen((prev) => !prev);

    setTaskDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        start: updatedStart,
        end: updatedEnd,
      },
    }));
  };

  const handleDateStartChange = (newDate) => {
    if (!startDateTime || !endDateTime) return;
    const previousDiff = endDateTime.getTime() - startDateTime.getTime();
    const updatedStart = new Date(startDateTime);
    updatedStart.setFullYear(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
    const updatedEnd = new Date(updatedStart.getTime() + previousDiff);

    setStartDateTime(updatedStart);
    setEndDateTime(updatedEnd);

    setIsDateStartOpen((prev) => !prev);

    setTaskDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        start: updatedStart,
        end: updatedEnd,
      },
    }));
  };

  const handleTimeEndChange = (newTime) => {
    if (!endDateTime) return;
    const updated = new Date(endDateTime);
    updated.setHours(newTime.getHours(), newTime.getMinutes(), 0, 0);
    setEndDateTime(updated);

    setIsTimeEndOpen((prev) => !prev);

    setTaskDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        end: updated,
      },
    }));
  };

  const handleDateEndChange = (newDate) => {
    if (!endDateTime) return;
    const updated = new Date(endDateTime);
    updated.setFullYear(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
    setEndDateTime(updated);

    setIsDateEndOpen((prev) => !prev);

    setTaskDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        end: updated,
      },
    }));
  };

  const handleBuffModeChange = (isBuffMode) => {
    setIsBuffMode(isBuffMode);
    if (!isBuffMode) {
      // NOTE 게스트 있을 시(미티 시) 기본값은 public
      setVisibilityType("public");
    } else {
      setVisibilityType(defaultVisibility);
    }
  };

  const handleDateClear = () => {
    setStartDateTime(null);
    setEndDateTime(null);
    setTaskDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        start: null,
        end: null,
        recurrence: null,
      },
    }));
  };

  const style = {
    backgroundColor: isDisabled
      ? "#242626"
      : hover
        ? `${getSpaceColor(inProgressAndCompletedSpaceList, spaceId)}`
        : `${getSpaceColor(inProgressAndCompletedSpaceList, spaceId)}${isDone ? "" : "26"} `,
    boxShadow: `0 0 0 1px ${isDisabled ? "#484D4D" : getSpaceColor(inProgressAndCompletedSpaceList, spaceId)} inset`,
    cursor: isDisabled ? "not-allowed" : "pointer",
  };
  const handleIconEnter = () => {
    setHover(true);
  };

  const handleIconLeave = () => {
    setHover(false);
  };

  return isModalNoteClicked ? (
    <div
      style={{ height: noteModalHeight }}
      className={styles.modalNote}
      onKeyDown={(e) => {
        // NOTE 노트 내 backspace 입력 시 블록 삭제되는 이슈 방지
        e.stopPropagation();
      }}
    >
      <TaskNote
        isChangeNote={isChangeNote}
        onSave={onSave}
        expand={expand}
        localTitle={localTitle}
      />
    </div>
  ) : (
    <>
      <div className={clsx({ [styles["setting"]]: !expand, [styles["setting--expand"]]: expand })}>
        <div
          className={clsx(styles["setting-state"], {
            [styles["setting-state--expand"]]: expand,
          })}
        >
          {isTask && (
            <div
              className={`${styles["setting-state-checkbox"]} ${styles[`${isDone ? "checkboxCompleted" : null}`]} ${isDisabled ? styles.disabled : ""}`}
              style={style}
              onClick={handleCheckbox}
              onMouseEnter={handleIconEnter}
              onMouseLeave={handleIconLeave}
            ></div>
          )}

          <TaskDetailTitle
            titleText={localTitle}
            blockType={taskDetail.data?.blockType}
            isFullPage={expand}
            titleRef={titleRef}
            handleChangeLocalTitle={handleChangeLocalTitle}
            handleResizeHeight={handleResizeHeight}
            onSave={onSave}
            updateTaskConfig={updateTaskConfig}
            isNewTask={taskDetail?.isNewBlock ?? false}
            isInputQuickSpaceShortcut={isInputQuickSpaceShortcut}
          />
        </div>
        <div
          className={clsx(styles["setting-property"], {
            [styles["setting-property--expand"]]: expand,
          })}
        >
          <SpaceModal
            expand={expand}
            projectDropdownRef={projectDropdownRef}
            titleRef={titleRef}
            handleChangeLocalTitle={handleChangeLocalTitle}
            isInputQuickSpaceShortcut={isInputQuickSpaceShortcut}
            setIsInputQuickSpaceShortcut={setIsInputQuickSpaceShortcut}
          />
          <DateModal
            dateTimeStart={startDateTime}
            dateTimeEnd={endDateTime}
            setStartDateTime={setStartDateTime}
            setEndDateTime={setEndDateTime}
            isAllDay={isAllDay}
            setIsAllDay={setIsAllDay}
            handleDateClear={handleDateClear}
            onCloseRepeat={() => handlePropertyBtn(null)}
            expand={expand}
            repeatModalRef={repeatModalRef}
            repeatAddModalRef={repeatAddModalRef}
            // Picker states
            isTimeStartOpen={isTimeStartOpen}
            setIsTimeStartOpen={setIsTimeStartOpen}
            isTimeEndOpen={isTimeEndOpen}
            setIsTimeEndOpen={setIsTimeEndOpen}
            isDateStartOpen={isDateStartOpen}
            setIsDateStartOpen={setIsDateStartOpen}
            isDateEndOpen={isDateEndOpen}
            setIsDateEndOpen={setIsDateEndOpen}
            // Picker handlers
            onTimeStartChange={handleTimeStartChange}
            onTimeEndChange={handleTimeEndChange}
            onDateStartChange={handleDateStartChange}
            onDateEndChange={handleDateEndChange}
            timeFormat={timeFormat}
          />

          {isEvent && (
            <>
              <GuestModal
                onClose={() => handlePropertyBtn(null)}
                setIsBuffMode={handleBuffModeChange}
                expand={expand}
                guestDropdownRef={guestDropdownRef}
                mutateMeetingCode={mutateMeetingCode}
              />
              {/* Notice: Location search가 미흡한 부분이 있어, 이를 보완할 때가지 당분간 comment out*/}
              {/*<LocationMenu*/}
              {/*  locationDropdownRef={locationDropdownRef}*/}
              {/*  location={currentLocation}*/}
              {/*  onChangeLocation={onChangeLocation}*/}
              {/*  expand={expand}*/}
              {/*/>*/}
              <VideoModal
                expand={expand}
                isBuffMode={isBuffMode}
                videoCreateModalRef={videoCreateModalRef}
                mutateMeetingCode={mutateMeetingCode}
                isPendingMeetingCode={isPendingMeetingCode}
                meetingCode={meetingCode}
              />
            </>
          )}

          <LinkModal
            expand={expand}
            linkMoreModalRef={linkMoreModalRef}
          />
        </div>
        {/* expand일 때 선택 탭 */}

        {expand && (
          <div className={styles.select_tab}>
            <button className={styles["select_tab--btn"]}>
              <span>Notes</span>
            </button>
          </div>
        )}
        <NotePreview
          expand={expand}
          isChangeNote={isChangeNote}
          onSave={onSave}
          localTitle={localTitle}
          noteData={taskDetail.data?.note}
          setIsModalNoteClicked={setIsModalNoteClicked}
        />
      </div>
    </>
  );
}
